import { useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// project-imports
import { ThemeModeProvider, useThemeMode } from 'context/ThemeModeContext';
import router from 'routes';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

function AppShell() {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  const appTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: { main: '#22c55e' },
          background: {
            default: isDark ? '#0a0f1a' : '#f8fafc',
            paper: isDark ? '#111827' : '#ffffff'
          },
          text: {
            primary: isDark ? '#e2e8f0' : '#0f172a',
            secondary: isDark ? '#94a3b8' : '#475569'
          },
          divider: isDark ? 'rgba(148, 163, 184, 0.1)' : 'rgba(148, 163, 184, 0.15)'
        },
        typography: {
          fontFamily: 'var(--fuzzscan-ui-font)',
          fontSize: 14,
          h1: { fontSize: '2rem', fontWeight: 800, lineHeight: 1.15 },
          h2: { fontSize: '1.78rem', fontWeight: 800, lineHeight: 1.15 },
          h3: { fontSize: '1.56rem', fontWeight: 800, lineHeight: 1.2 },
          h4: { fontSize: '1.38rem', fontWeight: 800, lineHeight: 1.2 },
          h5: { fontSize: '1.22rem', fontWeight: 800, lineHeight: 1.22 },
          h6: { fontSize: '1.08rem', fontWeight: 800, lineHeight: 1.25 },
          subtitle1: { fontSize: '0.98rem', fontWeight: 600 },
          subtitle2: { fontSize: '0.9rem', fontWeight: 600 },
          body1: { fontSize: '0.95rem', lineHeight: 1.5 },
          body2: { fontSize: '0.88rem', lineHeight: 1.45 },
          button: { fontSize: '0.88rem', fontWeight: 700, textTransform: 'none' },
          overline: { fontSize: '0.72rem', letterSpacing: '0.07em', fontWeight: 700 }
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              body: {
                backgroundColor: isDark ? '#0a0f1a' : '#f8fafc',
                color: isDark ? '#e2e8f0' : '#0f172a'
              }
            }
          },
          MuiCard: {
            styleOverrides: {
              root: {
                backgroundColor: isDark ? '#111827' : '#ffffff',
                borderRadius: 12,
                backgroundImage: 'none'
              }
            }
          },
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: 'none'
              }
            }
          }
        }
      }),
    [mode, isDark]
  );

  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <AppShell />
    </ThemeModeProvider>
  );
}

export default App;
